import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-newest-asset-card',
  templateUrl: './newest-asset-card.component.html',
  styleUrls: ['./newest-asset-card.component.scss']
})
export class NewestAssetCardComponent implements OnInit {

  @Input() newestAssetArray: any;
  username: any;

  constructor(private _appService: AppService, private router: Router) { }

  ngOnInit(): void {
    this._appService.getUsername().subscribe(userdata => this.username = userdata);
  }

  onViewClick(asset_id: any) {
    this._appService.getAllAssets(1, asset_id, this.username).subscribe((res) => {
      this.router.navigate(["/assetdetails/", res[0].Asset_Id], { state: res[0] })
      this._appService.upateAssetViewCount(this.username, asset_id).subscribe((res) => {
      });
    });

  }

}
